import { Icon, TextField } from "@shopify/polaris";
import { SearchMinor } from "@shopify/polaris-icons";
import { debounce } from "lodash";
import React, { useCallback, useState } from "react";
import { useCustomerList } from "../../context/CustomerListContext";
import { customerListActions } from "../../context/customerListReducer";
import { DEFAULT_DEBOUNCE_TIME } from "@vendor-app/constants/table";

export const CustomerSearch = () => {
  const { dispatch } = useCustomerList();
  const [search, setSearch] = useState("");

  const debouncedSetSearch = useCallback(
    debounce((searchText: string) => {
      dispatch(customerListActions.setSearchQuery(searchText));
    }, DEFAULT_DEBOUNCE_TIME * 3),
    [dispatch]
  );

  const updateSearch = useCallback(
    (newSearch: string) => {
      setSearch(newSearch);
      debouncedSetSearch(newSearch);
    },
    [debouncedSetSearch]
  );

  return (
    <TextField
      prefix={<Icon source={SearchMinor} />}
      autoComplete="off"
      label="Search by customer email, name"
      labelHidden
      value={search}
      onChange={updateSearch}
      placeholder="Search by customer email or name"
    />
  );
};
